/*
 * @Author: DYM
 * @Date: 2020-03-16 14:50:18
 * @LastEditors: DQL
 * @LastEditTime: 2020-09-14 17:16:06
 * @Description: 用户维护路由
 */

/* =============================================
   业务功能路由配置文件引入 Start
  *
  *
*/

// 用户维护
import attrUserRoutes from './user/user.routes.js';
// 用户维护
import attrDeptRoutes from './dept/dept.routes.js';

/* 业务功能路由配置文件引入 End */

/* =============================================
   业务功能路由配置写入 Start
  *
  *
*/
const FEATURES_ROUTES = [...attrUserRoutes, attrDeptRoutes];

/* 业务功能路由配置写入 End */

const attrRoutes = {
  path: 'attr',
  name: 'attr',
  component: { template: '<router-view></router-view>' },
  children: [
    ...FEATURES_ROUTES
  ]
};

export default attrRoutes;
